import { Route, Router } from "@angular/router";

import { notExternalOrParticipatingEntity, notPmoEntity, pmoEntity } from "../../core/guards";
import { AdaaHelper } from "../../core/utils";
import {
  viewCalculationManagementPageGuards,
  viewKpiAnnualWeightsEKPIPageGuards,
  viewKpiAnnualWeightsMOKPIPageGuards,
  viewKpiAnnualWeightsOPMPageGuards,
  viewKpiAnnualWeightsPageGuards,
  viewKpiAnnualWeightsSKPIPageGuards,
  viewKpiAnnualWeightsSRVKPIPageGuards,
} from "./_guards";

export const CALCULATION_MANAGEMENT_ROUTES: Route[] = [
  {
    path: "calculation-management",
    canActivate: [notExternalOrParticipatingEntity],
    children: [
      {
        path: "",
        loadComponent: () => import("../../shared/components").then((m) => m.SubmenuComponent),
      },
      {
        path: "calculation-government",
        loadComponent: () =>
          import("./calculation-government/calculation-government").then((m) => m.CalculationGovernmentComponent),
        canActivate: [pmoEntity, ...viewCalculationManagementPageGuards],
        data: {
          breadcrumb: "calculation.calculation_government",
          title: "calculation.calculation_government",
        },
      },
      {
        path: "calculation-entity-performance",
        loadComponent: () =>
          import("./calculation-entity/calculation-entity").then((m) => m.CalculationEntityComponent),
        canActivate: [pmoEntity, ...viewCalculationManagementPageGuards],
        data: {
          breadcrumb: "calculation.calculation_entity",
          title: "calculation.calculation_entity",
        },
      },
      {
        path: "kpi-annual-weights-conf",
        loadComponent: () =>
          import("./kpi-annual-weights-conf/kpi-annual-weights-conf").then((m) => m.KpiAnnualWeightsConfComponent),
        canActivate: [...viewKpiAnnualWeightsPageGuards, pmoEntity],
        data: {
          breadcrumb: "kpi_annual_weights.conf",
          title: "kpi_annual_weights.conf",
        },
      },
      {
        path: "kpi-annual-weights",
        canActivate: [notPmoEntity, ...viewKpiAnnualWeightsPageGuards],
        data: {
          breadcrumb: "breadcrumbs.kpi_annual_weights",
          title: "breadcrumbs.kpi_annual_weights",
        },
        children: [
          {
            path: "",
            loadComponent: () => import("../../shared/components").then((m) => m.SubmenuComponent),
            data: {
              onEntityChange: (router: Router) =>
                router.navigateByUrl(
                  AdaaHelper.isPMOEntity() ? "console" : "console/calculation-management/kpi-annual-weights"
                ),
            },
          },
          {
            path: "skpi",
            loadComponent: () =>
              import("./KPI-annual-weights/kpi-annual-weights/kpi-annual-weights").then(
                (m) => m.KPIAnnualWeightsComponent
              ),
            canActivate: [...viewKpiAnnualWeightsSKPIPageGuards],
            data: {
              breadcrumb: "kpi_annual_weights.strategic_kpi",
              title: "kpi_annual_weights.strategic_kpi",
              kpiType: 38,
            },
          },
          {
            path: "opm",
            loadComponent: () =>
              import("./KPI-annual-weights/kpi-annual-weights/kpi-annual-weights").then(
                (m) => m.KPIAnnualWeightsComponent
              ),
            canActivate: [...viewKpiAnnualWeightsOPMPageGuards],
            data: {
              breadcrumb: AdaaHelper.isPlanArchived() ? "kpi_annual_weights.operational_kpi" : "kpi_annual_weights.opm",
              title: AdaaHelper.isPlanArchived() ? "kpi_annual_weights.operational_kpi" : "kpi_annual_weights.opm",
              kpiType: 39,
            },
          },
          {
            path: "mokpi",
            loadComponent: () =>
              import("./KPI-annual-weights/kpi-annual-weights/kpi-annual-weights").then(
                (m) => m.KPIAnnualWeightsComponent
              ),
            canActivate: [...viewKpiAnnualWeightsMOKPIPageGuards],
            data: {
              breadcrumb: "kpi_annual_weights.mokpi",
              title: "kpi_annual_weights.mokpi",
              kpiType: 53,
            },
          },
          {
            path: "srvkpi",
            loadComponent: () =>
              import("./KPI-annual-weights/kpi-annual-weights/kpi-annual-weights").then(
                (m) => m.KPIAnnualWeightsComponent
              ),
            canActivate: [...viewKpiAnnualWeightsSRVKPIPageGuards],
            data: {
              breadcrumb: "kpi_annual_weights.service_kpi",
              title: "kpi_annual_weights.service_kpi",
              kpiType: 82,
            },
          },
          {
            path: "ekpi",
            loadComponent: () =>
              import("./KPI-annual-weights/kpi-annual-weights/kpi-annual-weights").then(
                (m) => m.KPIAnnualWeightsComponent
              ),
            canActivate: [...viewKpiAnnualWeightsEKPIPageGuards],
            data: {
              breadcrumb: "kpi_annual_weights.enabler_kpi",
              title: "kpi_annual_weights.enabler_kpi",
              kpiType: 41,
            },
          },
        ],
      },
    ],
    data: {
      breadcrumb: "calculation.calculation_management",
      title: "calculation.calculation_management",
    },
  },
];
